export default "__VITE_ASSET__BuQlaqAW__"